export default __webpack_public_path__ + "static/media/AddIcon.73ee3d42.svg";